<template>
  <div class="h100 bw">
    <OrderContact type="create" />
    <Empty
      text="请为客人添加商品"
      v-if="isBaseOrder && orderList.length == 0"
    />
    <div
      class="order-list"
      :class="{ 'base-order': isBaseOrder }"
      ref="list"
      v-if="isBaseOrder"
    >
      <van-swipe-cell
        v-for="(item, index) in orderList"
        :key="index"
        :ref="`swipeCell${index}`"
        @open="onSwipeOpen(index)"
        :disabled="!manualUploadImgEnabled"
      >
        <OrderItemCard
          :isCreate="true"
          :canOperate="true"
          :canModifyPrice="canModifyPrice"
          @changequantity="onQty"
          @delete="delProduct"
          @modifyprice="onModifyPrice"
          @openUploadImage="openUploadImage(index)"
          @openImageViewer="openImageViewer"
          :index="index"
          :data="item"
          :currentImageIndex="item.manualUploadImagesIndex || 0"
        />
        <template #right>
          <div class="upload"></div>
        </template>
      </van-swipe-cell>
    </div>
    <div v-else>
      <div class="not-rs-form">
        <div class="mb40 form-item-padding">
          <label class="label" for="orderAmount"
            ><span class="required">订金金额</span></label
          >
          <div class="text-input hidden" id="orderAmount">
            <input
              type="text"
              :value="orderForm.orderAmount"
              @input="onOrderAmountInput"
              @blur="onOrderAmountBlur"
              :placeholder="`¥ 请输入订金金额`"
              class="input"
              maxlength="20"
            />
          </div>
        </div>
        <div class="mb40 form-item-padding">
          <label class="label" for="customerRemark">备注 (客人可见)</label>
          <div class="text-input hidden" id="customerRemark">
            <input
              type="text"
              v-model="orderForm.customerRemark"
              placeholder="请输入备注"
              class="input"
              maxlength="100"
            />
          </div>
        </div>
        <div class="mb40 form-item-padding">
          <label class="label" for="innerRemark">备注 (仅内部可见)</label>
          <div class="text-input hidden" id="innerRemark">
            <input
              type="text"
              v-model="orderForm.innerRemark"
              placeholder="请输入备注"
              class="input"
              maxlength="100"
            />
          </div>
        </div>
        <div>
          <label class="label connect-label form-item-padding" for="orderList"
            ><span>关联商品</span></label
          >
          <InnerEmpty v-if="orderList.length === 0" text="请为客人添加商品" />
          <div class="order-list" id="orderList">
            <van-swipe-cell
              v-for="(item, index) in orderList"
              :key="index"
              :ref="`swipeCell${index}`"
              @open="onSwipeOpen(index)"
              :disabled="!manualUploadImgEnabled"
            >
              <OrderItemCard
                :canModifyPrice="false"
                is-create
                :hideAdjust="true"
                :index="index"
                :data="item"
                :currentImageIndex="item.manualUploadImagesIndex || 0"
                @changequantity="onQty"
                @delete="delProduct"
                @modifyprice="onModifyPrice"
                @openUploadImage="openUploadImage(index)"
                @openImageViewer="openImageViewer"
              />
              <template #right>
                <div class="upload"></div>
              </template>
            </van-swipe-cell>
          </div>
        </div>
      </div>
    </div>
    <div class="add-btn-container" :class="{ relative: relativeButton }">
      <div class="total-amount" v-show="totalAmount">
        商品总计：<span class="price-number">¥ {{ totalAmount }}</span>
      </div>
      <van-button
        class="w100"
        :type="orderList.length || !isBaseOrder ? 'default' : 'primary'"
        @click.prevent="onAddProduct"
        >{{ orderList.length === 0 ? '添加商品' : '继续添加' }}</van-button
      >
      <van-button
        v-show="orderList.length || !isBaseOrder"
        :disabled="
          (!isBaseOrder && !orderForm.orderAmount) ||
          orderForm.orderAmount === '0'
        "
        type="primary"
        class="w100"
        @click.native="onSubmit"
      >
        {{ isModify ? '申请调价并生成订单' : '生成订单' }}
      </van-button>
    </div>
    <van-popup
      class="add-product-modal"
      position="bottom"
      :close-on-click-overlay="false"
      closeable
      :value="showProductModal"
      @click-close-icon="closeProductModal"
    >
      <div class="add-product-inner-modal" ref="addProductModal">
        <div class="add-product-modal-title">添加商品</div>
        <div>
          <div class="">
            <div
              class="mb40 error-input-container"
              :class="{ error: skuError }"
            >
              <label class="label" for="inputSku"
                >商品货号<sup style="color: #ff4242">*</sup></label
              >
              <div class="text-input sku-input" id="inputSku">
                <input
                  type="search"
                  enterkeyhint="search"
                  v-model="inputSku"
                  @input="onSkuInput"
                  class="input inner-sku-input"
                  placeholder="请输入商品货号"
                  @keyup.enter="onSkuInputBlur"
                />
                <div
                  class="clear-btn"
                  v-show="inputSku"
                  @click.prevent="onClearSku"
                >
                  <img
                    class="clear-icon"
                    src="../../assets/icons/icon-input-clear.svg"
                    alt=""
                  />
                </div>
                <div class="scan-btn" @click.prevent="onScan">
                  <img src="@/assets/icons/scan-code.svg" alt="" />
                </div>
                <div class="suggested-sku_list" v-show="showSuggestion">
                  <div
                    class="suggested-sku_item c:row-between-center"
                    @click="onSelectSku(item)"
                    v-for="(item, index) in suggestProductSkus"
                    :key="index"
                  >
                    <span>{{ item }}</span>
                    <div class="suggested-sku_item-checkbox">
                      <img
                        v-show="selectItem === item"
                        src="@/assets/icons/checked.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    class="empty-suggest"
                    v-show="suggestProductSkus.length === 0"
                  >
                    暂无内容
                  </div>
                </div>
              </div>
              <div class="sku-error-text" v-show="skuError">货号不存在</div>
            </div>
            <div class="mb40">
              <label class="label" for="proName">商品名称</label>
              <div class="text-input hidden" id="proName">
                <input
                  disabled
                  type="text"
                  placeholder="商品名称"
                  v-model="searchProduct.proName"
                  class="input no-common-ligatures"
                />
              </div>
            </div>
            <div class="mb40">
              <label class="label" for="color">颜色</label>
              <div class="text-input hidden" id="color">
                <input
                  disabled
                  type="text"
                  placeholder="颜色信息"
                  v-model="searchProduct.color"
                  class="input no-common-ligatures"
                />
              </div>
            </div>
            <div class="mb40">
              <label class="label" for="size">尺码</label>
              <div class="text-input hidden" id="size">
                <input
                  disabled
                  placeholder="尺码信息"
                  type="text"
                  v-model="searchProduct.size"
                  class="input no-common-ligatures"
                />
              </div>
            </div>
            <div class="mb40">
              <label class="label" for="innerRemark">备注（内部可见）</label>
              <div class="text-input hidden" id="innerRemark">
                <input
                  type="text"
                  v-model="searchProduct.innerRemark"
                  placeholder="请填写备注"
                  maxlength="100"
                  class="input no-common-ligatures"
                />
              </div>
            </div>
            <div class="mb30">
              <label class="label" for="remark">备注（客人可见）</label>
              <div class="text-input" id="remark">
                <input
                  type="text"
                  v-model="searchProduct.remark"
                  class="input"
                  placeholder="请填写备注"
                  maxlength="100"
                />
              </div>
            </div>
            <div class="ts-box mt12" v-show="needShowStock">
              门店库存(仅供参考)：<span class="stock-number">{{
                stockNumber === undefined ? '-' : stockNumber
              }}</span>
            </div>
            <div class="ts-box">下单前请在系统中确认最终库存</div>
            <div class="add-product-bottom-btn">
              <van-button
                :disabled="!searchProduct.proName"
                class="w100"
                type="primary"
                @click.native="onConfirmAddSku"
                >确定添加</van-button
              >
            </div>
          </div>
        </div>
      </div>
    </van-popup>
    <AdjustPricePopup
      :show.sync="showModifyPrice"
      :data="modifyData"
      @submit="submitNewPrice"
      :default-remark="changeRemark"
      :default-price="modifyPrice"
    />
    <CConfirm ref="refCConfirm" />
    <UploadImageActionSheet
      v-model="uploadImageShow"
      @select="onSelectUploadImage"
    />
    <ImageEditor
      :visible="imageEditorVisible"
      :imageUrl="selectedImageUrl"
      @cancel="onImageEditorCancel"
      @confirm="onImageEditorConfirm"
    />

    <!-- 图片查看器 -->
    <ImageViewer
      :visible="imageViewerVisible"
      :images="currentImages"
      :initial-index="currentImageIndex"
      @close="closeImageViewer"
      @delete="handleImageDelete"
      @upload="handleImageUpload"
      @change="onImageViewerChange"
    />
  </div>
</template>
<script>
  import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
  import { setStore } from '@/utils/storage'
  import {
    searchSkusApi,
    submitOrderApi,
    searchSkySuggestApi,
    upload
  } from '@/api'
  import Empty from '@/components/common/Empty.vue'
  import InnerEmpty from '../../components/common/InnerEmpty.vue'
  import OrderContact from '@/components/order/sections/OrderContact.vue'
  import OrderItemCard from '@/components/order/widgets/OrderItemCard.vue'
  import AdjustPricePopup from '@/components/common/AdjustPricePopup.vue'
  import { outputmoney, outputdollars } from '@/utils/number'
  import { debounce, chooseDomImage } from '@/utils'
  import Config from '@/config'
  import {
    useDefaultWeWorkAgentConfig,
    getCurExternalContact
  } from '@/utils/wechat'
  import CConfirm from '@/components/common/CConfirm.vue'
  import UploadImageActionSheet from '@/components/order/popups/UploadImageActionSheet.vue'
  import ImageEditor from '@/components/common/ImageEditor.vue'
  import ImageViewer from '@/components/common/ImageViewer.vue'

  export default {
    data() {
      return {
        isBaseOrder: true,
        selectItem: false,
        stockNumber: undefined,
        suggestProductSkus: [],
        relativeButton: false,
        showProductModal: false,
        orderList: [],
        inputSku: '',
        showSuggestion: false,
        userId: '',
        showModifyPrice: false,
        modifyData: {},
        modifyPrice: '',
        remark: '',
        isModify: false,
        changeRemark: '',
        searchProduct: {},
        orderForm: {},
        needShowSuggest: false,
        needShowStock: false,
        canModifyPrice: false,
        skuError: false,
        uploadImageShow: false,
        uploadImageIndex: -1,
        imageEditorVisible: false,
        selectedImageUrl: '',
        imageViewerVisible: false,
        currentImages: [],
        currentImageIndex: 0,
        currentOrderIndex: -1
      }
    },
    components: {
      Empty,
      OrderContact,
      InnerEmpty,
      OrderItemCard,
      AdjustPricePopup,
      CConfirm,
      UploadImageActionSheet,
      ImageEditor,
      ImageViewer
    },
    watch: {
      orderList: function (val) {
        let count = 0
        val.forEach(v => {
          if (v.adjustedPrice) {
            count++
          }
        })
        if (count > 0) {
          this.isModify = true
        } else {
          this.isModify = false
        }
      }
    },
    computed: {
      ...mapState(['customerInfo', 'user', 'brandInfo']),
      ...mapGetters(['isSalerAccount']),
      manualUploadImgEnabled() {
        // return this.brandInfo.extra.manualUploadImgEnabled || true
        return true
      },
      totalAmount() {
        if (!this.isBaseOrder) {
          return this.orderForm.orderAmount || ''
        }
        if (this.orderList.length === 0) return ''
        let total = 0
        this.orderList.forEach(item => {
          if (item.adjustedPrice || item.price) {
            total += Number(item.adjustedPrice || item.price) * item.qty
          }
        })
        return total.toFixed(2)
      }
    },
    methods: {
      ...mapMutations(['setCustomerInfo']),
      ...mapActions(['getCustomerInfo']),
      init() {
        let that = this
        if (this.user.name && !this.isSalerAccount) {
          that.$dialog
            .alert({
              title: '提示',
              message: '仅SA可以进行下单，请确认权限'
            })
            .then(() => {
              that.$router.replace({
                path: '/'
              })
            })
        }
        this.$toast.loading({
          message: '',
          forbidClick: true
        })
        useDefaultWeWorkAgentConfig()
          .then(() => {
            return getCurExternalContact()
          })
          .then(res => {
            this.userId = res.userId
            return this.getUserInfoAndCheckRegistered()
          })
          .finally(() => {
            this.$toast.clear()
          })
        // 开发用
        if (Config.isDevelopment) {
          // this.userId = 'wmBOtMCwAA-YW24kuwVQixZN2uc1ayAA'
          this.userId = 'wmNf8SEwAAszIAexWKfE4Pw0JbRyN_gA'
          this.getUserInfoAndCheckRegistered()
        }
      },
      getUserInfoAndCheckRegistered() {
        if (!this.isSalerAccount) return Promise.reject('非SA账号')
        return this.$store
          .dispatch('getCustomerInfo', { userId: this.userId })
          .then(() => {
            return this.checkCustomerIsRegistered()
          })
      },
      async checkCustomerIsRegistered() {
        if (
          this.brandInfo.cdbQuery?.enabled &&
          this.customerInfo.inCDB === false
        ) {
          try {
            await this.$dialog.confirm({
              title: '客人尚未注册或绑定',
              message: this.brandInfo.cdbQuery.popupText,
              confirmButtonText: '发送注册链接',
              cancelButtonText: '继续下单'
            })
            wx.invoke(
              'sendChatMessage',
              {
                msgtype: 'miniprogram',
                enterChat: false,
                miniprogram: {
                  appid: this.brandInfo.cdbQuery.mpAppid,
                  title: `您的${this.brandInfo.brandName}客户顾问向您发送了注册链接`,
                  imgUrl: this.brandInfo.cdbQuery.mpCover,
                  page: this.brandInfo.cdbQuery.mpPath
                }
              },
              res => {
                console.log('sendChatMessage-res', res)
                if (res.err_msg == 'sendChatMessage:ok') {
                  this.$toast('发送成功')
                  this.sendComplete = true
                }
              }
            )
          } catch (error) {
            if (error?.message) this.$toast(error.message)
          }
        }
      },
      onClickNext() {
        this.$router.push({
          path: `/sa/create-order`,
          query: {
            orderType: this.orderTypes[this.selectTypeIndex].value,
            userId: this.userId
          }
        })
      },
      onQty(data) {
        this.orderList[data.index].qty = data.qty
      },
      onOrderAmountInput(e) {
        const value = e.target.value.replace(/,/g, '').replace(/¥ /g, '')
        if (
          /^$|^(0(\.\d{0,2})?|[1-9]\d*(\.\d{0,2})?|\.\d{0,2})$/.test(value) ||
          value == ''
        ) {
          this.$set(this.orderForm, 'orderAmount', outputdollars(value))
        } else {
          e.target.value = this.orderForm.orderAmount || ''
        }
      },
      onOrderAmountBlur() {
        const value = this.orderForm.orderAmount.replace(/,/g, '')
        this.$set(this.orderForm, 'orderAmount', outputmoney(value))
      },
      ToFixed: function (data, val) {
        let numbers = ''
        // 保留几位小数后面添加几个0
        for (let i = 0; i < val; i++) {
          numbers += '0'
        }
        let s = 1 + numbers
        // 如果是整数需要添加后面的0
        let spot = '.' + numbers
        // Math.round四舍五入
        //  parseFloat() 函数可解析一个字符串，并返回一个浮点数。
        let value = Math.round(parseFloat(data) * s) / s
        // 从小数点后面进行分割
        let d = value.toString().split('.')
        if (d.length == 1) {
          value = value.toString() + spot
          return value
        }
        if (d.length > 1) {
          if (d[1].length < 2) {
            value = value.toString() + '0'
          }
          return value
        }
      },
      delProduct(data) {
        this.$refs.refCConfirm
          .show('确认要删除此商品?')
          .then(() => {
            this.$toast('商品删除成功')
            this.orderList.splice(data.index, 1)
            this.onCalcHeight()
          })
          .catch(() => {})
      },
      onModifyPrice(data) {
        console.log('onModifyPrice', data)
        this.showModifyPrice = true
        this.modifyData = data
        this.changeRemark = data.data.adjustPriceInnerRemark
        this.modifyPrice = data.data.adjustedPrice
          ? data.data.adjustedPrice
          : data.data.price
      },
      onAddProduct() {
        this.showSuggestion = false
        this.inputSku = ''
        this.searchProduct = {}
        this.stockNumber = undefined
        this.showProductModal = true
      },
      onCalcHeight() {
        this.$nextTick(() => {
          if (this.$refs.list.offsetHeight + 340 > window.screen.height) {
            this.relativeButton = true
          } else {
            this.relativeButton = false
          }
        })
      },
      // 获取建议
      onSuggest: debounce(function () {
        if (this.inputSku.trim().length < 4) return false
        this.inputSku = this.inputSku.trim()
        this.$toast.loading({
          message: '查询中',
          forbidClick: true
        })
        searchSkySuggestApi(this.inputSku)
          .then(data => {
            this.suggestProductSkus = (data || []).map(
              item => item.split('|')[0]
            )
            this.showSuggestion = true
            this.selectItem = ''
          })
          .finally(() => {
            this.$toast.clear()
          })
      }, 500),
      checkImg(imgurl) {
        return new Promise(function (resolve, reject) {
          let imgObj = new Image()
          imgObj.src = imgurl
          imgObj.onload = function (res) {
            resolve(res)
          }
          imgObj.onerror = function (err) {
            reject(err)
          }
        })
          .then(() => {
            return true
          })
          .catch(() => {
            return false
          })
      },
      onClearSku() {
        this.inputSku = ''
        this.skuError = ''
        this.showSuggestion = false
      },
      onSkuInputBlur() {
        if (this.needShowSuggest) {
          this.onSuggest()
        } else {
          this.onSearchProduct()
        }
      },
      onSelectSku(item) {
        this.selectItem = item
        this.inputSku = item
        this.onSearchProduct()
        this.showSuggestion = false
      },
      onSkuInput() {
        this.skuError = false
        if (this.needShowSuggest && this.inputSku.trim().length >= 4) {
          this.onSuggest()
        } else {
          this.showSuggestion = false
        }
      },
      onSearchProduct() {
        if (this.inputSku == '') return false
        this.showSuggestion = false
        this.$toast.loading({
          message: '加载中',
          forbidClick: true
        })
        searchSkusApi(this.inputSku)
          .then(res => {
            this.$toast.clear()
            if (res) {
              this.stockNumber = res.stock || undefined
              this.searchProduct = {
                ...res,
                proName: res.productName,
                proDesc: res.description.replace(/<br\/>/g, ''),
                price: Number(res.price).toFixed(2).toString(),
                color: res.color,
                size: res.size,
                originalPrice: res.originalPrice
              }
            } else {
              this.searchProduct = {}
              this.skuError = true
            }
          })
          .catch(() => {
            this.skuError = true
          })
      },
      closeProductModal() {
        if (this.$refs['addProductModal']) {
          this.$refs['addProductModal'].scrollTop = 0
        }
        this.showProductModal = false
      },
      async onConfirmAddSku() {
        if (this.inputSku && !this.searchProduct.proName) {
          await this.onSearchProduct()
        } else if (this.inputSku == '' || this.searchProduct.proName == '') {
          this.$toast('商品不存在')
          return false
        }
        if (
          !/(?!^0*(\.0{1,2})?$)^\d{1,13}(\.\d{1,2})?$/.test(
            this.searchProduct.price
          )
        ) {
          this.$toast('价格格式不正确')
          return false
        }
        this.closeProductModal()
        this.$toast('添加成功')
        let pic = ''
        if (this.searchProduct.pic && this.checkImg(this.searchProduct.pic)) {
          pic = this.searchProduct.pic
        }
        this.$set(this.searchProduct, 'pic', pic)

        const sameProductIndex = this.orderList.findIndex(
          item => item.sku === this.searchProduct.sku
        )
        if (sameProductIndex !== -1) {
          this.$set(
            this.orderList[sameProductIndex],
            'qty',
            this.orderList[sameProductIndex].qty + 1
          )

          setStore('orderList', this.orderList)
          return
        } else {
          this.$set(this.searchProduct, 'qty', 1)
          this.orderList.push(this.searchProduct)
          setStore('orderList', this.orderList)
          this.onCalcHeight()
        }
      },
      onSubmit() {
        if (!this.isBaseOrder && !this.orderForm.orderAmount) {
          this.$toast('订金金额不能为空')
          return false
        }
        this.$refs.refCConfirm
          .show('确认生成订单？')
          .then(() => {
            this.$toast.loading({
              message: '加载中',
              forbidClick: true
            })
            let items = []
            this.orderList.forEach(item => {
              let _data = {
                sku: item.sku,
                qty: item.qty,
                remark: item.remark || '',
                innerRemark: item.innerRemark || '',
                productName: item.name,
                adjustPrice: item.adjustedPrice,
                adjustPriceInnerRemark: item.adjustPriceInnerRemark,
                manualUploadImages: JSON.stringify(item.manualUploadImages)
              }
              items.push(_data)
            })
            submitOrderApi({
              items: items,
              externalUserId: this.userId,
              type: this.isBaseOrder ? '1' : '2',
              depositAmount: this.isBaseOrder
                ? this.totalAmount
                : String(
                    parseFloat(this.orderForm.orderAmount.replace(/,/g, ''))
                  ),
              remark: this.orderForm.customerRemark || '',
              innerRemark: this.orderForm.innerRemark || ''
            })
              .then(res => {
                this.$toast.clear()
                if (this.isModify) {
                  return this.$router.replace(
                    '/sa/order?orderNo=' + res.orderNo
                  )
                }
                this.$router.replace('/sa/share-order?orderNo=' + res.orderNo)
              })
              .catch(() => {
                this.$toast('生成失败')
              })
          })
          .catch(() => {})
      },
      onScan() {
        wx.scanQRCode({
          needResult: 1,
          desc: '扫商品码',
          scanType: ['qrCode', 'barCode'],
          success: res => {
            console.log('scanQRCode res', res)
            if (res.errMsg === 'scanQRCode:ok') {
              this.inputSku = (res.resultStr || '').slice(0, 9)
              this.onSearchProduct()
              this.showSuggestion = false
            }
          },
          fail: function (err) {
            console.error('scanQRCode fail', err)
            if (err.errMsg.indexOf('function_not_exist') > 0) {
              this.$toast('版本过低请升级')
            }
          },
          error: function (err) {
            console.error('scanQRCode error', err)
            if (err.errMsg.indexOf('function_not_exist') > 0) {
              this.$toast('版本过低请升级')
            }
          }
        })
      },
      submitNewPrice({ modifyPrice, changeRemark }) {
        if (modifyPrice == '') {
          this.$toast('调整后价格不可为空')
          return false
        }
        if (
          parseFloat(modifyPrice) ==
          parseFloat(this.orderList[this.modifyData.index].price)
        ) {
          this.$toast('调整后价格应不等同于原价')
          return false
        }
        this.$set(
          this.orderList[this.modifyData.index],
          'adjustedPrice',
          modifyPrice
        )
        this.$set(
          this.orderList[this.modifyData.index],
          'adjustPriceInnerRemark',
          changeRemark
        )
        this.showModifyPrice = false
      },
      // 处理滑动单元格打开事件，自动关闭
      onSwipeOpen(index) {
        setTimeout(() => {
          const swipeCell = this.$refs[`swipeCell${index}`]
          if (swipeCell && swipeCell[0]) {
            swipeCell[0].close()
          }
          this.openUploadImage(index)
        }, 100)
      },
      openUploadImage(index) {
        this.uploadImageIndex = index
        this.uploadImageShow = true
      },
      closeUploadImage() {
        this.uploadImageShow = false
      },
      async onSelectUploadImage(type) {
        let res = null
        if (type === 'camera') {
          res = await chooseDomImage({
            sourceType: 'camera'
          })
        }
        if (type === 'album') {
          res = await chooseDomImage({
            sourceType: 'album'
          })
        }
        console.log('chooseDomImage-res', res)
        const file = res[0]
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => {
          this.selectedImageUrl = reader.result
          this.imageEditorVisible = true
        }
      },

      onImageEditorCancel() {
        this.imageEditorVisible = false
        this.selectedImageUrl = ''
      },

      async onImageEditorConfirm(result) {
        console.log('图片编辑完成:', result)
        // 先转换base64为File
        const response = await fetch(result.url)
        const blob = await response.blob()
        const file = new File([blob], 'image.jpg', { type: 'image/jpeg' })
        const filename = await this.upload(file)
        const orderList = JSON.parse(JSON.stringify(this.orderList))

        // 添加安全检查
        if (
          this.uploadImageIndex < 0 ||
          this.uploadImageIndex >= orderList.length ||
          !orderList[this.uploadImageIndex]
        ) {
          console.error(
            'Invalid uploadImageIndex:',
            this.uploadImageIndex,
            'orderList length:',
            orderList.length
          )
          this.$toast('上传失败：无效的订单索引')
          return
        }

        if (!orderList[this.uploadImageIndex].manualUploadImages) {
          orderList[this.uploadImageIndex].manualUploadImages = []
          orderList[this.uploadImageIndex].manualUploadImageShows = []
        }
        orderList[this.uploadImageIndex].manualUploadImages.push(filename)
        orderList[this.uploadImageIndex].manualUploadImageShows.push(result.url)
        this.orderList = orderList
        // 回显的方法
        // const imgBlob = await fileRead(filename)
        // const imageUrl = URL.createObjectURL(imgBlob)
        // console.log('imageUrl', imageUrl)
        console.log('this.orderList', this.orderList)
        this.imageEditorVisible = false
        this.selectedImageUrl = ''
      },
      async upload(file) {
        const formData = new FormData()
        formData.append('file', file)
        try {
          this.$toast.loading({
            message: '上传中',
            forbidClick: true
          })
          const filename = await upload(formData)
          console.log('filename', filename)
          return filename
        } catch (error) {
          console.log('upload error', error)
          if (error?.message) this.$toast(error.message)
          else this.$toast.clear()
        }
      },
      // 图片查看器相关方法
      openImageViewer({ orderIndex, imageIndex, images }) {
        this.currentOrderIndex = orderIndex
        this.currentImageIndex = imageIndex
        this.currentImages = images
        // 初始化item的图片索引
        const currentItem = this.orderList[orderIndex]
        if (!currentItem.hasOwnProperty('manualUploadImagesIndex')) {
          this.$set(currentItem, 'manualUploadImagesIndex', imageIndex)
        }
        this.imageViewerVisible = true
      },
      closeImageViewer() {
        this.imageViewerVisible = false
        this.currentImages = []
        this.currentImageIndex = 0
        this.currentOrderIndex = -1
      },
      handleImageDelete(imageIndex) {
        if (this.currentOrderIndex === -1) return
        const orderList = JSON.parse(JSON.stringify(this.orderList))
        const orderItem = orderList[this.currentOrderIndex]
        if (
          !orderItem.manualUploadImages ||
          orderItem.manualUploadImages.length === 0
        ) {
          this.$toast('无法删除原始商品图片')
          return
        }
        if (imageIndex > 0) {
          const deleteIndex = imageIndex - 1
          orderItem.manualUploadImages.splice(deleteIndex, 1)
          orderItem.manualUploadImageShows.splice(deleteIndex, 1)
          this.currentImages.splice(imageIndex, 1)
          this.orderList = orderList
          if (this.currentImages.length === 0) {
            this.closeImageViewer()
          } else if (this.currentImageIndex >= this.currentImages.length) {
            this.currentImageIndex = this.currentImages.length - 1
          }
          const currentItem = this.orderList[this.currentOrderIndex]
          if (this.currentImageIndex < this.currentImages.length) {
            this.$set(
              currentItem,
              'manualUploadImagesIndex',
              this.currentImageIndex
            )
          } else {
            this.$set(currentItem, 'manualUploadImagesIndex', 0)
          }
          this.$nextTick(() => {
            this.$forceUpdate()
          })
          this.$toast('图片删除成功')
        } else {
          this.$toast('无法删除原始商品图片')
        }
      },

      handleImageUpload() {
        if (this.currentOrderIndex === -1) {
          console.warn('handleImageUpload: currentOrderIndex is -1')
          this.$toast('无法上传图片：未选择有效订单')
          return
        }
        if (
          this.currentOrderIndex >= this.orderList.length ||
          !this.orderList[this.currentOrderIndex]
        ) {
          console.error(
            'handleImageUpload: invalid currentOrderIndex:',
            this.currentOrderIndex,
            'orderList length:',
            this.orderList.length
          )
          this.$toast('无法上传图片：订单索引无效')
          return
        }
        // 保存currentOrderIndex，因为closeImageViewer会重置它
        const targetOrderIndex = this.currentOrderIndex
        this.closeImageViewer()
        this.openUploadImage(targetOrderIndex)
      },

      onImageViewerChange(index) {
        this.currentImageIndex = index
        if (this.currentOrderIndex !== -1) {
          const currentItem = this.orderList[this.currentOrderIndex]
          this.$set(currentItem, 'manualUploadImagesIndex', index)
        }
      }
    },
    mounted() {
      if (this.$route.query.userId) {
        this.userId = this.$route.query.userId
      } else {
        this.init()
      }

      this.isBaseOrder = this.$route.query.orderType === '1'
      this.needShowSuggest = this.brandInfo.autocomplete?.enabled === true
      this.needShowStock = this.brandInfo.stockVisibility?.enabled === true
      this.canModifyPrice = this.brandInfo.modifyPrice?.enabled === true
    }
  }
</script>
<style lang="less">
  .add-product_btn {
    width: 48/20rem;
    height: 48/20rem;
    background: url('../../assets/images/add.png');
    display: block;
    background-size: 100% auto;
    position: fixed;
    bottom: 192/20rem;
    right: 13/20rem;
    z-index: 5;
  }

  .add-product-modal {
    width: 100%;

    .van-button {
      height: 1.9rem !important;
      line-height: 1.9rem !important;
    }

    .scan-btn {
      width: 22/20rem;
      height: 22/20rem;
      // background: url("../../assets/icons/scan-code.svg");
      display: block;
      background-size: 100% auto;
      position: absolute;
      right: 8px;
      top: 50%;
      margin-top: -10/20rem;
    }
  }
  .add-product-inner-modal {
    width: 100%;
    max-height: calc(100vh - 80px);
    padding: 0/20rem 20/20rem 80/20rem;
    position: relative;
    overflow-y: auto;
  }
  .add-product-bottom-btn {
    position: fixed;
    width: 100%;
    left: 0;
    bottom: 0;
    padding: 1rem 1rem;
    background-color: #fff;
  }

  .suggested-sku_list {
    background: #fff;
    font-size: 12px;
    color: #aaaaaa;
    position: absolute;
    z-index: 1200;
    border: 1px solid #aaaaaa;
    width: 100%;
    overflow-y: scroll;
    height: 196/20rem;
    top: 120%;

    .suggested-sku_item {
      color: #000;
      height: 46/20rem;
      padding: 0 16/20rem;
      border-bottom: 1px solid #e4e4e4;
      &-checkbox {
        width: 22/20rem;
        height: 22/20rem;
        border-radius: 50%;
        border: 1px solid #dcdddf;
      }
    }
  }
  .order-list {
    padding: 0 0rem 120/20rem;
    &.base-order {
      padding-left: 1rem;
      padding-right: 1rem;
    }
  }

  .price-input {
    .icon-left {
      font-size: 14px;
      line-height: 2rem;
      padding-left: 10px;
      position: absolute;
      color: #aaaaaa;
    }
  }

  .hidden {
    overflow: hidden;
  }

  .van-dialog__confirm .van-button__text {
    color: #000;
  }

  .kc-box {
    display: inline-block;
    // margin-left:0.5rem;
  }

  .ts-box {
    color: #666666;
    font-size: 12px;
    line-height: 24/20rem;
  }
  .mb40 {
    margin-bottom: 40/40rem;
  }
  .add-product-modal-title {
    text-align: center;
    font-size: 16px;
    font-weight: 500;
    padding: 20/20rem 0;
    line-height: 1;
    position: sticky;
    top: 0;
    width: 100%;
    left: 0;
    background-color: #fff;
    z-index: 1;
  }
  .mt12 {
    margin-top: 12/20rem;
  }
  .add-btn-container {
    position: absolute;
    width: 100%;
    bottom: 0;
    display: flex;
    align-items: center;
    gap: 12/20rem;
    padding: 52/20rem 20/20rem 20/20rem;
    background-color: #fff;
    .total-amount {
      font-size: 11px;
      position: absolute;
      z-index: 1;
      top: 16/20rem;
      right: 20/20rem;
      .price-number {
        font-size: 15px;
        font-weight: 500;
      }
    }
  }

  .not-rs-form {
    padding: 60/40rem 20/20rem 50/40rem;
    font-size: 12px;
  }
  .empty-suggest {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .h100 {
    overflow-y: auto;
  }
  .sku-error-text {
    color: #ed7867;
    font-size: 12px;
    margin-top: 4/20rem;
  }
  .sku-input {
    padding-right: 60/20rem;
    display: flex;
    align-items: center;
  }
  .clear-btn {
    position: absolute;
    right: 1.8rem;
    padding: 0.5rem;
    .clear-icon {
      width: 16/20rem;
      height: 16/20rem;
    }
  }
  .error-input-container.error {
    .sku-input {
      border-color: #ed7867;
    }
  }
  .upload {
    width: 4rem;
    height: 100%;
    background: #fff;
  }
</style>
